import Vue from 'vue'
import VueRouter from 'vue-router'

// 使用动态导入，避免路径问题
const Layout = () => import('../layout/index.vue')
const Login = () => import('../views/login/Login.vue')

Vue.use(VueRouter)

// 常量路由：登录页和隐藏/通用页面（不需要在菜单管理中配置）
// 其他菜单路由通过菜单管理动态配置
const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    hidden: true,
    meta: { title: '登录' }
  },
  // 审批相关的通用路由
  {
    path: '/approval',
    component: Layout,
    hidden: true,
    children: [
      // 审批表单页（通过程序跳转访问）
      {
        path: 'form',
        name: 'ApprovalForm',
        component: () => import('../views/approval/ApprovalForm.vue'),
        meta: { title: '审批表单' },
        hidden: true
      },
      // 审批分类页（通过路径参数传递流程编码）
      // 菜单配置时，path 设为 /approval/category/xxx，xxx 为流程编码
      {
        path: 'category/:flowCode?',
        name: 'ApprovalCategory',
        component: () => import('../views/approval/ApprovalCategory.vue'),
        meta: { title: '审批列表' },
        hidden: true
      }
    ]
  }
]

function createRouter() {
  return new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes
  })
}

const router = createRouter()

/** 清空动态路由注册的 matcher，换账号登录后必须调用，否则会沿用上一用户的菜单路由 */
export function resetRouter() {
  const fresh = createRouter()
  router.matcher = fresh.matcher
}

export { constantRoutes }
export default router